var _path, _path2, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPaymentsBgLayer3(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1769,
    height: 287,
    viewBox: "0 0 1769 287",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0.901367H1769V281.849C1769 284.611 1766.76 286.849 1764 286.849H4.99999C2.23857 286.849 0 284.611 0 281.849V0.901367Z",
    fill: "#0C3330"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_15_8",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 1769,
    height: 287
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0.901367H1769V281.849C1769 284.611 1766.76 286.849 1764 286.849H4.99999C2.23857 286.849 0 284.611 0 281.849V0.901367Z",
    fill: "#0C3330"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_15_8)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1606.02 -1127.18C2112.21 -1087.17 2763.9 -693.763 2689.66 -161.469C2615.42 370.824 2144.89 769.903 1638.69 729.897C1132.49 689.892 782.323 225.952 856.563 -306.342C930.803 -838.636 1099.82 -1167.19 1606.02 -1127.18Z",
    fill: "#6DFFFE",
    fillOpacity: 0.1
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaymentsBgLayer3);
export default __webpack_public_path__ + "static/media/payments_bg_layer3.c96ae9d1216a809d90f0c8e16a5f6a60.svg";
export { ForwardRef as ReactComponent };